const CookiesAnalytics = (() => {
  function getCookie(cookieName) {
    const cookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${cookieName}=`));

    if (cookie) {
      return cookie.split('=')[1];
    }

    return null;
  }

  function setCookie(cookieName, cookieValue) {
    const date = new Date();

    date.setMonth(date.getMonth() + 13);
    document.cookie = `${cookieName}=${cookieValue};expires=${date}`;
  }

  return {
    getCookie,
    setCookie,
  };
})();

export default CookiesAnalytics;
